/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BillingInfo,
    BillingInfoFromJSON,
    BillingInfoFromJSONTyped,
    BillingInfoToJSON,
} from './BillingInfo';

/**
 * 
 * @export
 * @interface GetBillingInfoResponse
 */
export interface GetBillingInfoResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof GetBillingInfoResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetBillingInfoResponse
     */
    message: string;
    /**
     * 
     * @type {BillingInfo}
     * @memberof GetBillingInfoResponse
     */
    data: BillingInfo;
}

export function GetBillingInfoResponseFromJSON(json: any): GetBillingInfoResponse {
    return GetBillingInfoResponseFromJSONTyped(json, false);
}

export function GetBillingInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBillingInfoResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': BillingInfoFromJSON(json['data']),
    };
}

export function GetBillingInfoResponseToJSON(value?: GetBillingInfoResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': BillingInfoToJSON(value.data),
    };
}

